import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import api from 'lib/trpcClient';

const usePeriodEndReport = () => {
  const { mutate: save, ...saveMutation } =
    api.periodEndReport.save.useMutation(useHandleTrpcMutation()({}));

  const { mutate: publish, ...publishMutation } =
    api.periodEndReport.publish.useMutation(useHandleTrpcMutation()({}));

  return {
    saving: saveMutation.isPending || publishMutation.isPending,
    save,
    publish,
  };
};

export default usePeriodEndReport;
